import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { SvgAtlasComponent } from '@bioreferencehealth/ui-kit';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, SvgAtlasComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {}
